import React, { useEffect, useState, Component, useRef } from 'react';
import { Button, ButtonGroup, Dropdown, DropdownButton, Form } from 'react-bootstrap';
import firebase from 'firebase';

import FirebaseService from '../../../services/firebase';

const Chat = (props) => {

    const subscription = useRef(null)
    var subscriptionAccount = null;

    const messagesEndRef = useRef(null);

    const [lastContact, setLastContact] = useState(null);
    const [messages, setMessages] = useState([]);
    const [account, setAccount] = useState({});
    const [message, setMessage] = useState('');

    const dateOptions = {
        year: "2-digit",
        month: "2-digit",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
    };

    const getChatData = (page) => {
        let subData = FirebaseService.getChatMessages(props.contactData.id, page, handleChatData);
        subscription.current = subData;
    }

    const handleChatUpdate = async () => {
        setLastContact(props.contactData);

        if (subscription.current) await subscription.current();

        if (props.contactData?.id) {
            getChatData(1);
        }
    }

    const handleChatData = (data) => {
        setMessages(data.docs);
    }

    const updateAccount = (snapshot) => {
        setAccount(snapshot.data());
    }

    const isoOwnMessage = (uid) => {
        return uid === account.id
    }

    const sendMensage = (event) => {
        event.preventDefault();
        if (message) {
            const chatMessage = {
                content: message,
                timestemp: firebase.firestore.FieldValue.serverTimestamp(),
                uid: props.contactData.userId,
                tracking: {
                    [props.contactData.userId]: new Date()
                },
                name: account.name
            }

            FirebaseService.createChatMessage(props.contactData.id, chatMessage)
            FirebaseService.updateContact(props.contactData.userId, props.contactData.id, { lastMessage: new Date() })
            FirebaseService.updateContact(props.contactData.contactId, props.contactData.id, {
                unreadMessages: firebase.firestore.FieldValue.increment(1),
                lastMessage: new Date(),
            })

            setMessage('');
        }
    }

    const deleteMessage = (message) => {
        message.ref.delete();
    } 

    useEffect(() => {
        if (!subscriptionAccount) subscriptionAccount = FirebaseService.subscribeAccount(updateAccount);
        if (props.contactData?.id !== lastContact?.id) handleChatUpdate();
    }, [props]);

    return (
        <div className="chat-component">
            <div className="chat-messages">
                {messages.map(message =>
                    <div className={`chat-message ${isoOwnMessage(message.get('uid')) ? 'own-message' : ''}`} key={message.id}>
                        <div className="chat-message-name">
                            <p className="chat-message-name-title">{message.get('name')}</p>
                            <DropdownButton className="chat-message-name-button" size="sm" variant="outline-primary" as={ButtonGroup} title="" id="bg-vertical-dropdown">
                                <Dropdown.Item eventKey="1" onClick={() => deleteMessage(message)}>Excluir</Dropdown.Item>
                            </DropdownButton>
                        </div>
                        <p>{message.get('content')}</p>
                        <p className="chat-message-date">{message.get('timestemp')?.toDate().toLocaleString('pt-BR', dateOptions)}</p>
                    </div>)}
            </div>
            {props.contactData && <Form className="chat-send-form" onSubmit={sendMensage} autoComplete="off">
                <Form.Group className="chat-send-field" controlId="formMessage">
                    <Form.Control type="text" value={message || ''} placeholder="Digite sua mensagem" onChange={(data) => setMessage(data.target.value)} />
                </Form.Group>
                <Button className="chat-send-btn" variant="primary" type="submit">
                    Enviar
                </Button>
            </Form>}

        </div>
    );
}

export default Chat;